export const SHARE_CODE_REGEX = /^[A-Z0-9]{16}$/;

export function isShareCode(value: string): boolean {
  return SHARE_CODE_REGEX.test(value);
}

/**
 * Share links live at the root path since api #152
 * (way.arrivesafe.app/{code}), but legacy `/w/{code}` links survive in old
 * SMS messages and the mobile app's deep-link handling — scanning every
 * segment accepts both without a routing table. First valid segment wins.
 */
export function extractShareCode(pathname: string): string | null {
  for (const segment of pathname.split('/')) {
    if (!segment) continue;
    const candidate = segment.toUpperCase();
    if (isShareCode(candidate)) return candidate;
  }
  return null;
}
